export default {
  plural: 'Метки',
  singular: 'Метка',
  new: 'Добавить метку',
  add: 'Добавить метки',
  change: 'Изменить метки',
  createTag: 'Создать тег',
  createTeamCustomTag: 'Создать кастомный тег компании',
  deleteTag: 'Удалить тег',
  deleteWarning:
    'Вы уверены, что хотите удалить тег? Это действие нельзя отменить.',
  tagType: 'Тип тега',
  removeAllOtherTags: 'Удалить все остальные теги',
  select: 'Выбрать метки...'
};
